/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import throttle from 'lodash/throttle';
import PropTypes from 'prop-types';
import { OffsetProvider } from '../../../contexts/OffsetContext';
import { layoutContainerCss } from './index.styles';
import StickyMobile from './StickyMobile';
import StickyDesktop from './StickyDesktop';
import { SafePureComponent } from '../../../utils/SafePureComponent';

export class LayoutSticky extends SafePureComponent {
  static propTypes = {
    rendering: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.onScroll = throttle(this.onScroll, 25);
    this.containerRef = React.createRef();

    this.state = {
      top: 0,
      bottom: 0,
      scrolledPercentage: 0,
    };
  }

  onScroll = () => {
    const rect = this.containerRef.current.getBoundingClientRect();
    const top = Math.max(rect.top * -1, 0);
    const bottom = rect.bottom - window.innerHeight;
    const scrolledPercentage = Math.min(
      Math.max(top / (rect.height - window.innerHeight), 0),
      1,
    );

    this.setState({ top, bottom, scrolledPercentage });
  };

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  safeRender() {
    const { rendering } = this.props;
    const { top, bottom, scrolledPercentage } = this.state;
    const parentDimensions = { top, bottom, scrolledPercentage };

    return (
      <OffsetProvider value={{ offsetLeft: 2 }}>
        <div css={[layoutContainerCss]} ref={this.containerRef}>
          <StickyMobile parentDimensions={parentDimensions} />
          <StickyDesktop {...this.props} parentDimensions={parentDimensions} />
          <Placeholder name="jss-offset-left" rendering={rendering} />
        </div>
      </OffsetProvider>
    );
  }
}

LayoutSticky.displayName = 'LayoutSticky';

export default LayoutSticky;
